import { __read, __spread } from "tslib";
import { formatValue as valueFormatter } from '@keen.io/charts-utils';
import { KEEN_KEY, KEEN_VALUE } from '@keen.io/parser';
import { calculatePercent } from '../../utils';
import { FUNNEL_STEP, VALUE, PERCENTAGE_VALUE } from '../../constants';
export var transform = function (_a) {
    var chartSettings = _a.chartSettings;
    var data = chartSettings.data, formatValues = chartSettings.formatValues, stepLabels = chartSettings.stepLabels;
    var columns = [FUNNEL_STEP, VALUE, PERCENTAGE_VALUE];
    return __spread([
        columns
    ], data.map(function (item, idx, collection) {
        var _a;
        var previousStepTotal = (_a = collection[idx - 1]) === null || _a === void 0 ? void 0 : _a[KEEN_VALUE];
        var percentageValue = idx === 0 ? 100 : 0;
        if (previousStepTotal) {
            percentageValue = calculatePercent(item[KEEN_VALUE], previousStepTotal);
        }
        return [
            (stepLabels === null || stepLabels === void 0 ? void 0 : stepLabels[idx]) ? stepLabels[idx] : item[KEEN_KEY],
            valueFormatter(item[KEEN_VALUE], formatValues),
            percentageValue + "%",
        ];
    }));
};
